import { useState, useEffect } from "react";
import { LANGTYPE_EN, LangType, useLanguage } from "@/app/utils/LanguageContext";
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from "@mui/material/TableHead";
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import React from 'react';
import styled from "styled-components";
import JackpotStar from "@/app/ui/Common/SvgComponent/JackpotStar";
import { GET_MEETING_GENERAL_INFORMATION } from "@/app/utils/request/query";
import { getMeetingGeneralInformation } from "@/app/utils/request/requestList";
import { useMyContext } from "@/app/utils/MyContext";
import _ from 'lodash';
import { formattedDate, dateFormat, toDate } from "@/app/utils/DayJS";
import { textSize, text_size } from "@/app/utils/MixinSize";
import { getJcbwDomain, getSearchParams, setRacesDetailLoading, formattedNumber } from "@/app/utils/Common";
import NoInformation from "@/app/ui/Common/NoInformation";
import Jackpotremarks from "./jackpotremarks"
import { oddType } from "@/app/utils/constant/odd";

const Title = styled.div`
  width: 100%;
  height: 36px;
  line-height: 16px;
  padding: 12px;
  ${text_size(15)}
  font-weight: 500;
  background-color: #F4F4F4;
  color: #333333
`;

const MeetingContainer = styled.div`
  width: 100%;
  line-height: 17.71px;
  padding: 12px;
  ${text_size(13)}
  font-weight: 500;
  background-color: #FFFFFF;
  border-radius: 0px 0px 4px 4px;
`;

const BettingPoolTable = styled(Table)(() => ({
    [`&`]: {
        boxShadow: "0px 2px 10px 0px rgb(0 0 0 / 10%)"
    },
    [`&.${TableRow}`]: {
        backgroundColor: "#FFFFFF !important",
    }
  }));

  const GeneralInfoTable = styled(Table)(() => ({
    [`&`]: {
        backgroundColor: "#FFFFFF",
    }
  }));

const BettingPoolTableRow = styled(TableRow)<{ $index?: any }>(({ $index }) => ({
    [`&:nth-of-type(even)`]: {
        backgroundColor: "#F4F4F4",
    },
    [`&:nth-of-type(odd)`]: {
        backgroundColor: "#FFFFFF",
    },
    [`&`]: {
      backgroundColor: $index==undefined? "inherit": $index%2 == 0 ? "#FFFFFF !important" :"#F4F4F4 !important"
    },
  }));
const JackPotTableRow = styled(TableRow)<{ $index?: any }>(({ $index }) => ({
    [`&`]: {
        padding: '0 8px',
        backgroundColor: $index%2 == 0 ? "#FFFFFF !important": "#F4F4F4 !important"
    },
    // [`&:nth-of-type(even)`]: {
    //     backgroundColor: "#FFFFFF",
    // },
    // [`&:nth-of-type(odd)`]: {
    //     backgroundColor: "#F4F4F4",
    // }
}));

const BettingPoolTableCell = styled(TableCell)(() => ({
    [`&`]:{
        verticalAlign: "middle",
    },
    [`&.${tableCellClasses.head}`]: {
      color: "#333333",
      backgroundColor: "#E1E1E1",
      fontWeight: 400,
      padding: "8px",
      ...textSize(11),
      textAlign: "left",
      height: "16px",
      lineHeight: "14px",
    },
    [`&.${tableCellClasses.body}`]: {
        color: "#333333",
        fontWeight: 500,
        padding: "8px",
        ...textSize(13),
        textAlign: "left",
        height: "40px",
        lineHeight: "18px",
      }
  }));

  const MultiLegPoolTableCell = styled(TableCell)(() => ({
    [`&[data-jpt="true"]`]:{
        verticalAlign: "bottom",
    },
    [`&.${tableCellClasses.body}`]: {
        color: "#333333",
        fontWeight: 500,
        padding: "8px",
        ...textSize(13),
        textAlign: "left",
        height: "40px",
        lineHeight: "18px",
    },
    [`&.${tableCellClasses.body}[colspan="4"]`]:{
        color: "#333333",
    }
  }));

const SingleLegListItem = styled(ListItem)(() => ({
  [`&`]: {
    display: "inline",
    width: "23.13px",
    height: "18px",
    textAlign: "center",
    ...textSize(13),
    fontWeight: 500,
    lineHeight: "18px",
    borderRight: "1px solid #E1E1E1",
    padding: "0px"
  },
  [`&:first-child`]: {
    borderLeft: "1px solid #E1E1E1"
  }
}));

const SingleLegListMobileItem = styled(ListItem)(() => ({
    [`&`]: {
      height: "42px",
      justifyContent: "center",
      textAlign: "center",
      ...textSize(13),
      fontWeight: 500,
      borderRight: "1px solid #E1E1E1",
      margin: "0px !important",
    }
  }));

const SingleLegListLink = styled(Link)<{ $assetPrefix: string }>(({ $assetPrefix }) => ({
    [`&`]: {
        display: "inline-flex",
        color: "#122C68"
    },
    [`&[data-jpt="true"]:after`]:{
        content: "''",
        width: "7px",
        height: "7px",
        backgroundImage: `url(${$assetPrefix}/jackpot_s.svg)`
    }
  }));

  const MultiLegListLink = styled(Link)(() => ({
    [`&`]: {
        display: "inline-flex",
        color: "#122C68",
    }
  }));

const TableHeader = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
      color: "#FFFFFF",
      backgroundColor: "#6176A0",
      fontWeight: 400,
      padding: "8px",
      ...textSize(13),
      textAlign: "left",
      height: "36px",
      lineHeight: "16px",
    }
  }));

const SingleLegPoolTableMobileCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.root}`]: {
        color: "#333333",
    },
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#E1E1E1",
        fontWeight: 400,
        padding: "8px",
        ...textSize(11),
        height: "32px",
        lineHeight: "16px",
        borderBottom: "0px",
      },
    [`&.${tableCellClasses.body}`]: {
        color: "#333333",
        ...textSize(13),
        fontWeight: 500,
        textAlign: "left",
        height: "18px",
        lineHeight: "18px"
    },
}));

const MultiLegPoolTableMobileCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.root}`]: {
        ...textSize(13),
        height: "18px",
        lineHeight: "18px",
        verticalAlign: "middle",
    },
    [`&.${tableCellClasses.body}`]: {
        fontWeight: 500,
        padding: "8px"
    },
    [`&.${tableCellClasses.body}:nth-child(1)`]: {
        color: "#333333",
        width: "164px",
    },
    [`&.${tableCellClasses.body}:nth-child(2)`]: {
        color: "#122C68",
        width: "75px",
        textAlign: "right",
    },
}));

const StyledTableRow = styled(TableRow)<{ $index?: any }>(({ $index }) => ({
    '&:nth-of-type(even)': {
        backgroundColor: "#F4F4F4",
    },
    '&:nth-of-type(odd)': {
        backgroundColor: "#FFFFFF",
    },
    ['&']: {
        backgroundColor: $index == undefined ? "inherit": $index%2 == 0 ? "#F4F4F4 !important" : "#FFFFFF !important",
    },
    'td': {
        border: 0,
        ...textSize(13),
        lineHeight: "18px",
    }
}));

const MultiLegPoolDivider = styled(Divider)(() => ({
    [`&[data-leg="0"]`]: {
        display: "none",
    }
}));

const MeetingSummary = styled.div`
    &{
        padding: 12px 0;
    },
`;

const JackpotLabel = styled('div')<{ $assetPrefix: string }>(({ $assetPrefix }) => `
    &{
        width: fit-content;
        height: fit-content;
        // min-width: 57px;
        min-height: 15px;
        ${text_size(10)}
        color: #122C68;
        font-weight: 500;
        line-height: 12px;
        background-color: #FFD505;
        border-radius: 100px;
        padding: 2px 4px;
        vertical-align: middle;
        align-items: center;
        display: flex;
    },
    &:before{
        display: inline-block;
        width: 8px;
        height: 7.98px;
        content: '';
        margin-right: 2px;
        vertical-align: middle;
        background-image: url(${$assetPrefix}/JackpotStar_S.svg);
        background-repeat: no-repeat;
        background-position: center;
    }
`);

const JackpotLabelMobile = styled('div')<{ $assetPrefix: string }>(({ $assetPrefix }) => `
    &{
        width: fit-content;
        height: fit-content;
        // min-width: 72px;
        min-height: 22px;
        ${text_size(13)}
        color: #122C68;
        font-weight: 500;
        line-height: 13px;
        background-color: #FFD505;
        border-radius: 100px;
        padding: 2px 4px;
        vertical-align: middle;
        align-items: center;
        display: flex;
    },
    &:before{
        display: inline-block;
        width: 14px;
        height: 13.96px;
        content: '';
        margin-right: 4px;
        vertical-align: middle;
        background-image: url(${$assetPrefix}/JackpotStar_L.svg);
        background-repeat: no-repeat;
        background-position: center;
    }
`);

const JackpotRemark = styled.div`
    &{
        ${text_size(13)}
        color: #333333;
        font-weight: 500;
        line-height: 11px;
        padding-top: 5px;
        display: flex;
        align-content: center;
        flex-wrap: nowrap;
        align-items: center;
    },
    &:before{
        content: '';
    }
    &>span{
        padding-left: 4px;
    }
`;

const EstimatedDividendLabel = styled.div`
    &{
        ${text_size(10)}
        color: #122C68;
        font-weight: 500;
        line-height: 11px;
        height: 18px;
        align-content: center;
    }
`;

const SingleLegMobileDiv = styled.div`
    &{
        display: inline;
        margin: 0px !important;
        width: 20%;
        height: 52px;
        padding: 5px 0;
    },
    &:nth-child(5n+1) li{
        border-left: 1px solid #E1E1E1;
    },
`;

const RemarksDiv = styled.div``;

const StyledRemarkDiv = styled('span')(() => ({
    'p': {
        ...textSize(13),
        fontWeight: 500,
        lineHeight: "16px",
        padding: "4px 0 0",
        color: "#333333"
    }
}));

interface propType {
  setRacesDetailLoading: (loading: boolean) => void;
    type?: string;
}

interface propPmPool {
    oddsType?: string;
    jackpot?: string;
    estimatedDividend?: string;
    leg?: propPmPoolLeg;
}

interface propPmPoolLeg {
    number?: number;
    races?: number[];
}

const GetBettingPool = (pmPools: any, t: any) => {
    const result = pmPools.reduce((acc: { [x: string]: any[]; }, pool: { oddsType: string; leg: propPmPoolLeg }) => {
        if (!acc[pool.oddsType]) {
            acc[pool.oddsType] = [];
        }
        acc[pool.oddsType].push(pool);
        acc[pool.oddsType].sort((a, b) => Number(a.leg.number) - Number(b.leg.number));
        return acc;
    }, {});

    return result;
}

const getPMUmsg = (pmPools:any, t:any) => {
    const showPool = [oddType.WIN, oddType.PLA];
    let PMUPool = [] as string[];
    const dividendInfo = pmPools.filter((x:any)=> x.comingleStatus > 0 && showPool.includes(x.oddsType));

    dividendInfo.map((item:any) => {
        if (!PMUPool.includes(item.oddsType)) { 
            PMUPool.push(item.oddsType);
        }
    })

    if (PMUPool.length > 1)
    {
        return t('generalInformation_outbound_remark').replace('{0}', t('result_france_outbound_PMU_oddsType_WP'));
    }
    else if (PMUPool.length === 1)
    {
        return t('generalInformation_outbound_remark').replace('{0}', t('oddsType_' + PMUPool[0]));
    }

    return '';
}

const GeneralInformation: React.FC<propType> = (props: propType) => {
    const singleLegPoolOrder = [oddType.WIN, oddType.PLA, oddType.QIN, oddType.QPL, oddType.FCT, oddType.TCE, oddType.TRI, oddType.FF, oddType.QTT];
    const multipleLegPoolOrder = [oddType.DBL, oddType.TBL, oddType.DT, oddType.TT, oddType.SIX_UP];
    const [bettingPoolData, setBettingPoolData] = useState<any>(null);
    const [meetingTime, setMeetingTime] = useState("");
    const [pmuRemarks, setPMURemarks] = useState("");
    const [hasSingleLegPoolJackpot, setHasSingleLegPoolJackpot] = useState(false);
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
    const { b_cid } = getSearchParams(new URLSearchParams(window.location.search));
    
    const { state: lang } = useLanguage();
    const { t } = lang;

    useEffect(() => {
        const venueCode = myContextState.selectedMeetingVenueCode;
        if (venueCode === '') {
            setRacesDetailLoading(props.setRacesDetailLoading)
            return
        }
        const meetingDate = formattedDate(myContextState.selectedMeetingDate, "YYYY-MM-DD");

        getMeetingGeneralInformation(
          {
            date: meetingDate,
            venueCode: venueCode,
            oddsTypes: [oddType.WIN, oddType.PLA, oddType.QIN, oddType.QPL, oddType.FCT, oddType.TCE, oddType.TRI, oddType.FF, oddType.QTT, oddType.DBL, oddType.TBL, oddType.DT, oddType.TT, oddType.SIX_UP]
          },
          GET_MEETING_GENERAL_INFORMATION,
          "qids"
        )
          .then((res: any) => {
            if (res?.raceMeetingProfile?.[0].races?.length) {
                setMeetingTime(formattedDate(toDate(res?.raceMeetingProfile?.[0].races?.[0].postTime, dateFormat.qids.datetime), dateFormat.display.fulldatetime));
            }
            const bettingPool = GetBettingPool(res?.raceMeetingProfile?.[0].pmPools, t);
            setBettingPoolData(bettingPool);
            const PMUmsg = getPMUmsg(res?.raceMeetingProfile?.[0].pmPools, t);
            setPMURemarks(PMUmsg);
            
            const hasJackpot = (oddsType: string) => {
                const odds = bettingPool[oddsType];
                return odds?.some((item: { jackpot: string; }) => (item.jackpot !== null || item.jackpot !== "") && parseFloat(item.jackpot) > 0);
            };
            setHasSingleLegPoolJackpot(hasJackpot('WIN') || hasJackpot('PLA') || hasJackpot('QIN') || hasJackpot('QPL') || hasJackpot('FCT') || hasJackpot('FF') || hasJackpot('QTT'));
        })
          .catch((e: any) => {
            console.log(e);
          }).finally(()=>{
            setRacesDetailLoading(props.setRacesDetailLoading)
          });
      }, [myContextState.selectedMeeting]);

    function formatJackpotEstDiv(value: string) {
        return (value !== null || value !== "") && parseFloat(value) > 0 ? `$${parseFloat(value).toLocaleString('en-us', { maximumFractionDigits: 2 })}` : "-";
    }

    const getBetLink = (oddsType:string, item:any, langType:LangType) => {
        let url = "";
        let lang = (langType === LANGTYPE_EN ? "/en" : "/ch");
        switch (oddsType) {
            case oddType.QIN:
            case oddType.QPL:
                url = lang + "/racing/wpq/"
                break;
            case oddType.FCT:
                url = lang + "/racing/fct/"
                break;
            case oddType.TCE:
                url = lang + "/racing/tce/"
                break;
            case oddType.TRI:
                url = lang + "/racing/tri/"
                break;
            case oddType.FF:
                url = lang + "/racing/ff/"
                break;
            case oddType.QTT:
                url = lang + "/racing/qtt/"
                break;
            case oddType.DBL:
                url = lang + "/racing/dbl/"
                break;
            case oddType.TBL:
                url = lang + "/racing/tbl/"
                break;
            case oddType.DT:
                url = lang + "/racing/dt/"
                break;
            case oddType.TT:
                url = lang + "/racing/tt/"
                break;
            case oddType.SIX_UP:
                url = lang + "/racing/6up/"
                break;
            case oddType.WIN:
            case oddType.PLA:
            default:
                url = lang + "/racing/wp/"
                break;
                
        }
        return getJcbwDomain() + url + formattedDate(myContextState.selectedMeetingDate, "YYYY-MM-DD") + '/' + myContextState.selectedMeeting?.meetingVenueCode + '/' + item[0] + '?b_cid=SPLDSP_racing/simulcast-Generalinformation_Odds';
    }
      
    const bettingDataNotEmptyObject = () => Object.keys(bettingPoolData || {}).length > 0;
    const ifNeedBorderBottom = (dataLength:any,index:any) => {
        if ((dataLength > 0 && dataLength <= 5) && index <=4) return 'unset'
        if ((dataLength > 5 && dataLength <= 10) && index <=4) return '1px solid #E1E1E1'
        if ((dataLength > 10 && dataLength <= 15) && index <=9) return '1px solid #E1E1E1'
        return 'unset'
    }

    const getJackPotForWinPLA = (rowData:any) => rowData?.filter((item:any) => item?.comingleStatus > 0 && ['WIN', 'PLA'].includes(item?.oddsType) && (item?.jackpot !== null || item?.jackpot !== "") && parseFloat(item?.jackpot) >= 0) || []
    const ifShowJackPotTextForWinPLA = (rowData:any) => {
        return getJackPotForWinPLA(rowData)?.length > 0
    }

    const renderJackPotForWinPLA = (rowData:any, index:any) => {
        return ifShowJackPotTextForWinPLA(rowData) ? <JackPotTableRow $index={index}><TableCell colSpan={24} style={{padding: "8px"}}>
        {getJackPotForWinPLA(rowData)?.map((item:any,index:any) => {
            // FPMU-27 (c) it is under un-commingled ,display 'Race X Jackpot: $0
            return <span key={index}>{`${t('changes_race')} ${item?.leg?.number} ${t("jackpot")}: $${item?.comingleStatus == '2' ? 0 :formattedNumber(item?.jackpot)}${index === getJackPotForWinPLA(rowData)?.length - 1 ? '': '/ '}`}</span>
        })}</TableCell></JackPotTableRow>: null
    }
    return (
        <>
            {props.type === "pc" ? (
                bettingPoolData === null ?
                <NoInformation/>
                :
                <div>
                    <Title id="GeneralInformation_Title"> {t('generalInformation_title')} </Title>
                    <MeetingContainer>
                        <MeetingSummary id="GeneralInformation_Meeting_Summary_pc">
                            {myContextState.selectedMeeting?.racedayName} ({myContextState.selectedMeeting?.meetingVenueCode} {myContextState.selectedMeeting?.countryName})<br />{meetingTime}
                        </MeetingSummary>
                        <TableContainer>
                            <GeneralInfoTable id="GeneralInformation_Table_pc" sx={{ border: "var(--border)", borderCollapse: "separate", borderRadius: "4px", overflow: "hidden", textAlign: "left !important" }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableHeader id="GeneralInformation_Title_pc" colSpan={2}>{t("bettingPool")} ({myContextState.selectedMeeting?.meetingVenueCode} {myContextState.selectedMeeting?.countryName})</TableHeader>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow sx={{backgroundColor: "#FFFFFF !important", verticalAlign: 'top'}}>
                                        {
                                            bettingDataNotEmptyObject() ? <>
                                                <TableCell sx={{width: "50%", padding: "0 0 10px 0"}}>
                                                    <BettingPoolTable sx={{borderRight: bettingDataNotEmptyObject() ? "1px solid #B4B4B4" : ''}}>
                                                            {
                                                                bettingDataNotEmptyObject() ? <TableHead>
                                                                        <TableRow>
                                                                        <BettingPoolTableCell sx={{width: "184px"}}>{t('dividend_pool')}</BettingPoolTableCell>
                                                                        <BettingPoolTableCell sx={{width: "392px"}}>{t('generalInformation_race')}</BettingPoolTableCell>
                                                                    </TableRow>
                                                                </TableHead>: null
                                                            }
                                                        <TableBody>
                                                            {singleLegPoolOrder.map((oddsType,index) => {
                                                                const oddsTypeCode = lang.langType === LANGTYPE_EN ? '' : '(' + t(`oddsType_code_${oddsType}`) + ')';
                                                                const rowData = bettingPoolData[oddsType];
                                                                    if (rowData && rowData.length > 0) {
                                                                        
                                                                        return (
                                                                            <>
                                                                                <BettingPoolTableRow $index={index}>
                                                                                    <BettingPoolTableCell id={`bettingPool_pool_${oddsType}_pc`}>{t(`oddsType_${oddsType}`)} {oddsTypeCode}</BettingPoolTableCell>
                                                                                    <BettingPoolTableCell id={`bettingPool_race_${oddsType}_pc`}>
                                                                                        <List component={Stack} direction="row" sx={{padding: "0px"}}>
                                                                                            {rowData.map((item: { jackpot: string; leg: {number: number; races: any[]; }; }, index: any) => {
                                                                                                const hasjackpot = (item.jackpot !== null || item.jackpot !== "") && parseFloat(item.jackpot) > 0;
                                                                                                return (
                                                                                                    <SingleLegListItem id={`bettingPool_race_${oddsType}_${index}_pc`} key={`bettingPool_race_${oddsType}_${index}_pc`}>
                                                                                                        <SingleLegListLink $assetPrefix={myContextState.assetPrefix}
                                                                                                        href={getBetLink(oddsType, item.leg.races, lang.langType)}
                                                                                                        data-jpt={hasjackpot}>{item.leg.races.join('/')}</SingleLegListLink>
                                                                                                    </SingleLegListItem>
                                                                                                )
                                                                                            })}
                                                                                        </List>
                                                                                    </BettingPoolTableCell>
                                                                                    
                                                                                </BettingPoolTableRow>
                                                                                {renderJackPotForWinPLA(rowData, index)}

                                                                                {oddsType=="QTT"&&<Jackpotremarks bettingPool={bettingPoolData} type={props.type}/>}
                                                                            </>
                                                                        );
                                                                    }
                                                                    return null;
                                                            })}
                                                        </TableBody>
                                                    </BettingPoolTable>
                                                    { hasSingleLegPoolJackpot ? <>
                                                        <JackpotRemark><JackpotStar sx={{width: "13px", height: "13px"}}></JackpotStar>
                                                        <span>{t("jackpot")}</span>
                                                        </JackpotRemark> 
                                                        </>: <></>
                                                    }
                                                </TableCell>
                                                <TableCell sx={{width: "50%", padding: "0 0 10px 0"}}>
                                                    <BettingPoolTable>
                                                        { 
                                                            bettingDataNotEmptyObject() ?  <TableHead><TableRow>
                                                                    <BettingPoolTableCell sx={{width: "184px"}}>{t('dividend_pool')}</BettingPoolTableCell>
                                                                    <BettingPoolTableCell colSpan={3} sx={{width: "392px"}}>{t('generalInformation_race')}</BettingPoolTableCell>
                                                                </TableRow>
                                                            </TableHead>: null
                                                        }
                                                        <TableBody>
                                                            {multipleLegPoolOrder.map((oddsType) => {
                                                                const rowData = bettingPoolData[oddsType];
                                                                const hasJackpot = () => {
                                                                    return rowData.some((item: { jackpot: string; }) => (item.jackpot !== null || item.jackpot !== "") && parseFloat(item.jackpot) > 0);
                                                                };
                                                                const hasEstimatedDividend = () => {
                                                                    return rowData.some((item: { estimatedDividend: string; }) => (item.estimatedDividend !== null || item.estimatedDividend !== "") && parseFloat(item.estimatedDividend) > 0);
                                                                };
                                                                if (rowData && rowData.length > 0) {
                                                                    return (
                                                                        <>
                                                                            {rowData.map((item: { jackpot: string; estimatedDividend: string; leg: {number: number; races: any[]; }; }, index: any) => (
                                                                                <>
                                                                                    <BettingPoolTableRow >
                                                                                        <MultiLegPoolTableCell id={`bettingPool_seq_${oddsType}_${index}_pc`} data-jpt={hasJackpot() || hasEstimatedDividend()}>{rowData.length > 1 ? t(`dividend_pool_no_${item.leg.number}`) : ''}{t(`oddsType_${oddsType}`)}</MultiLegPoolTableCell>
                                                                                        <MultiLegPoolTableCell id={`bettingPool_race_${oddsType}_${index}_pc`} data-jpt={hasJackpot() || hasEstimatedDividend()}><MultiLegListLink href={getBetLink(oddsType, item.leg.races, lang.langType)}>{item.leg.races.join('/')}</MultiLegListLink></MultiLegPoolTableCell>
                                                                                        {hasJackpot() || hasEstimatedDividend() ?
                                                                                            <>
                                                                                                <MultiLegPoolTableCell data-jpt={hasJackpot() || hasEstimatedDividend()}><JackpotLabel $assetPrefix={myContextState.assetPrefix}>{t("jackpot")}</JackpotLabel>{formatJackpotEstDiv(item.jackpot)}</MultiLegPoolTableCell>
                                                                                                <MultiLegPoolTableCell data-jpt={hasJackpot() || hasEstimatedDividend()}><EstimatedDividendLabel>{t("estimatedDividend")}</EstimatedDividendLabel>{formatJackpotEstDiv(item.estimatedDividend)}</MultiLegPoolTableCell>
                                                                                            </> :
                                                                                            <>
                                                                                                <MultiLegPoolTableCell></MultiLegPoolTableCell>
                                                                                                <MultiLegPoolTableCell></MultiLegPoolTableCell>
                                                                                            </>
                                                                                        }
                                                                                    </BettingPoolTableRow>
                                                                                    <BettingPoolTableRow></BettingPoolTableRow>
                                                                                </>
                                                                            ))}
                                                                            <BettingPoolTableRow></BettingPoolTableRow>
                                                                        </>
                                                                    );
                                                                }
                                                                return null;
                                                            })}
                                                        </TableBody>
                                                    </BettingPoolTable>
                                                </TableCell>
                                            </> : 
                                            <TableCell sx={{ padding: "0 0 10px 0"}}>
                                                 <NoInformation/>
                                            </TableCell>
                                        }
                                    </TableRow>
                                </TableBody>
                            </GeneralInfoTable>
                        </TableContainer>
                        <>{pmuRemarks !== '' ?<StyledRemarkDiv>
                                <p id={"Genrall_PMUNote"} dangerouslySetInnerHTML={{ __html: t('result_france_outbound_PMU_Note') }} />
                            </StyledRemarkDiv> : <></>}</>
                    </MeetingContainer>
                </div>
            ) : (
                bettingPoolData == null ?
                <NoInformation/>
                :
                <MeetingContainer style={{ boxShadow: "0px 2px 10px 0px rgb(0 0 0 / 10%)" }}>
                    <MeetingSummary id="GeneralInformation_Meeting_Summary_mobile">
                        {myContextState.selectedMeeting?.racedayName} ({myContextState.selectedMeeting?.meetingVenueCode} {myContextState.selectedMeeting?.countryName})<br />{meetingTime}
                    </MeetingSummary>
                    {bettingPoolData === null ? <></> : 
                    <>
                        <TableContainer sx={{ margin: "10px 0", borderRadius: "4px", overflow: "hidden",  boxShadow: "0px 2px 10px 0px rgb(0 0 0 / 10%)" }}>
                            <Table id="GeneralInformation_Table_bettingPool_mobile" sx={{ width: "100%" }} aria-label="simple table">
                                <TableHead id="GeneralInformation_TableHead_mobile">
                                    <TableRow>
                                        <TableHeader id="GeneralInformation_Title_mobile" colSpan={2}>{t("bettingPool")} ({myContextState.selectedMeeting?.meetingVenueCode} {myContextState.selectedMeeting?.countryName})</TableHeader>
                                    </TableRow>
                                    {
                                        bettingDataNotEmptyObject() ?<TableRow sx={{backgroundColor: "#E1E1E1"}}>
                                            <SingleLegPoolTableMobileCell sx={{width: "81px"}}>{t('dividend_pool')}</SingleLegPoolTableMobileCell>
                                            <SingleLegPoolTableMobileCell sx={{width: "234px", textAlign: "right"}}>{t('generalInformation_race')}</SingleLegPoolTableMobileCell>
                                        </TableRow> : <NoInformation/>
                                    }
                                </TableHead>
                                <TableBody>
                                    {singleLegPoolOrder.map((oddsType, index) => {
                                        const oddsTypeCode = lang.langType === LANGTYPE_EN ? '' : '(' + t(`oddsType_code_${oddsType}`) + ')';
                                        const rowData = bettingPoolData[oddsType];
                                            if (rowData && rowData.length > 0) {
                                                return (
                                                    <>
                                                        <StyledTableRow $index={index+1}>
                                                            <SingleLegPoolTableMobileCell id={`bettingPool_pool_${oddsType}_mobile`} sx={{padding: "8px"}}>{t(`oddsType_${oddsType}`)} {oddsTypeCode}</SingleLegPoolTableMobileCell>
                                                            <SingleLegPoolTableMobileCell id={`bettingPool_race_${oddsType}_mobile`} sx={{padding: "0px"}}>
                                                                <List component={Stack} spacing={{ xs: 5 }} direction="row" flexWrap="wrap" sx={{padding: "0px 8px"}}>
                                                                    {rowData.map((item: { jackpot: string; leg: {number: number; races: any[]; }; }, index: any) => (
                                                                        <SingleLegMobileDiv key={`bettingPool_race_${oddsType}_${index}_mobile`}
                                                                        style={{
                                                                            'border-bottom': ifNeedBorderBottom(rowData.length, index),
                                                                        } as React.CSSProperties}><SingleLegListMobileItem id={`bettingPool_race_${oddsType}_${index}_mobile`}><SingleLegListLink $assetPrefix={myContextState.assetPrefix} href={getBetLink(oddsType, item.leg.races, lang.langType)} data-jpt={(item.jackpot !== null || item.jackpot !== "") && parseFloat(item.jackpot) > 0}>{item.leg.races.join('/')}</SingleLegListLink></SingleLegListMobileItem></SingleLegMobileDiv>
                                                                    ))}
                                                                </List>
                                                            </SingleLegPoolTableMobileCell>
                                                        </StyledTableRow>
                                                       {renderJackPotForWinPLA(rowData, index)}
                                                        {oddsType=="QTT"&&<Jackpotremarks bettingPool={bettingPoolData} type={props.type}/>}
                                                    </>
                                                );
                                            }
                                            return null;
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        { hasSingleLegPoolJackpot ? <>
                            <JackpotRemark>
                                <JackpotStar sx={{width: "13px", height: "13px"}}></JackpotStar>
                                <span>{t("jackpot")}</span>
                            </JackpotRemark>
                            </>
                             : <></>
                        }
                        <TableContainer sx={{ margin: "10px 0", borderRadius: "4px", overflow: "hidden",  boxShadow: "0px 2px 10px 0px rgb(0 0 0 / 10%)" }}>
                            <Table id="GeneralInformation_Table_SingleLegPool_mobile" sx={{ width: "100%" }} aria-label="simple table">
                                <TableBody>
                                    {multipleLegPoolOrder.map((oddsType) => {
                                        const rowData = bettingPoolData[oddsType];
                                        const hasJackpot = () => {
                                            return rowData.some((item: { jackpot: string; }) => item.jackpot !== null);
                                        };
                                        const hasEstimatedDividend = () => {
                                            return rowData.some((item: { estimatedDividend: string; }) => (item.estimatedDividend !== null || item.estimatedDividend !== "") && parseFloat(item.estimatedDividend) > 0);
                                        };
                                        if (rowData && rowData.length > 0) {
                                            return (
                                                <>
                                                    {rowData.map((item: { jackpot: string; estimatedDividend: string; leg: {number: number; races: any[]; }; }, index: any) => (
                                                        <>
                                                            <StyledTableRow>
                                                                <TableCell sx={{padding: "0px 4px"}} colSpan={2}><MultiLegPoolDivider data-leg={index}></MultiLegPoolDivider></TableCell>
                                                            </StyledTableRow>
                                                            <StyledTableRow></StyledTableRow>
                                                            <StyledTableRow>
                                                                <MultiLegPoolTableMobileCell>{rowData.length > 1 ? t(`dividend_pool_no_${item.leg.number}`) : ''}{t(`oddsType_${oddsType}`)}</MultiLegPoolTableMobileCell>
                                                                <MultiLegPoolTableMobileCell><MultiLegListLink href={getBetLink(oddsType, item.leg.races, lang.langType)}>{item.leg.races.join('/')}</MultiLegListLink></MultiLegPoolTableMobileCell>
                                                            </StyledTableRow>
                                                            <StyledTableRow></StyledTableRow>
                                                            {hasJackpot() || hasEstimatedDividend() ?
                                                                <>
                                                                    <StyledTableRow>
                                                                        <MultiLegPoolTableMobileCell sx={{paddingTop: "0px !important"}}><JackpotLabelMobile $assetPrefix={myContextState.assetPrefix}>{t("jackpot")}</JackpotLabelMobile></MultiLegPoolTableMobileCell>
                                                                        <MultiLegPoolTableMobileCell sx={{paddingTop: "0px !important"}}>{formatJackpotEstDiv(item.jackpot)}</MultiLegPoolTableMobileCell>
                                                                    </StyledTableRow>
                                                                    <StyledTableRow></StyledTableRow>
                                                                    <StyledTableRow>
                                                                        <MultiLegPoolTableMobileCell sx={{paddingTop: "0px !important"}}>{t("estimatedDividend")}</MultiLegPoolTableMobileCell>
                                                                        <MultiLegPoolTableMobileCell sx={{paddingTop: "0px !important"}}>{formatJackpotEstDiv(item.estimatedDividend)}</MultiLegPoolTableMobileCell>
                                                                    </StyledTableRow>
                                                                    <StyledTableRow></StyledTableRow>
                                                                </> : <></>
                                                            }
                                                        </>
                                                    ))}
                                                    <BettingPoolTableRow></BettingPoolTableRow>
                                                </>
                                            );
                                        }
                                        return null;
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <>{pmuRemarks !== '' ?<StyledRemarkDiv>
                                <p id={"Genrall_PMUNote"} dangerouslySetInnerHTML={{ __html: t('result_france_outbound_PMU_Note') }} />
                            </StyledRemarkDiv> : <></>}</>
                    </>
                    }
                </MeetingContainer>
            )
            }
        </>
    )
}

export default GeneralInformation; 